module.exports = __webpack_public_path__ + "img/roleInvestor.61a21f0d.svg";